import DbErd from './DbErd.container';

export default DbErd;
